export default __webpack_public_path__ + "static/media/eb-pro-blk-poster-1.54909c8e.jpg";